import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";

const InstitutionalFooter = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-[#8B1B3A] text-white" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          
          {/* Column 1 - Solutions */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer.solutions')}
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-white/70 hover:text-white text-sm transition-colors">
                  {t('footer.assetTracking')}
                </Link>
              </li>
              <li>
                <span className="text-white/70 text-sm">{t('footer.elderaCare')}</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">{t('footer.healthMonitoring')}</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">{t('footer.mobileCare')}</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">{t('footer.allSolutions')}</span>
              </li>
            </ul>
          </div>

          {/* Column 2 - Company */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer.company')}
            </h3>
            <address className="not-italic text-white/70 text-sm leading-relaxed">
              <p className="font-medium text-white mb-1">0g Holding SA</p>
              <p>Rue Cavour 1</p>
              <p>1203 Geneva</p>
              <p className="mb-3">Switzerland</p>
              <p>
                Email:{" "}
                <a 
                  href="mailto:contact@0gholding.ch" 
                  className="hover:text-white transition-colors"
                >
                  contact@0gholding.ch
                </a>
              </p>
            </address>
          </div>

          {/* Column 3 - Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer.legal')}
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/privacy" className="text-white/70 hover:text-white text-sm transition-colors">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-white/70 hover:text-white text-sm transition-colors">
                  {t('footer.gdpr')}
                </Link>
              </li>
              <li>
                <span className="text-white/70 text-sm">{t('footer.terms')}</span>
              </li>
              <li>
                <span className="text-white/70 text-sm">{t('footer.imprint')}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom line */}
        <div className="border-t border-white/20 mt-10 pt-6">
          <p className="text-center text-white/60 text-sm">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default InstitutionalFooter;
